import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import * as SettingsActions from './settings.actions';
import { SettingsService } from '../../core/services/settings.service';

@Injectable()
export class SettingsEffects {
  private actions$ = inject(Actions);
  private settingsService = inject(SettingsService);

  loadSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SettingsActions.loadSettings),
      switchMap(() =>
        this.settingsService.findAll().pipe(
          map((response) => {
            // L'API retourne un tableau, on prend le premier élément
            const settings = Array.isArray(response) ? response[0] : response;
            return SettingsActions.loadSettingsSuccess({ settings });
          }),
          catchError((error) => {
            console.error('❌ Erreur lors de la récupération des settings:', error);
            return of(
              SettingsActions.loadSettingsFailure({
                error: error.message || 'Erreur lors du chargement des settings',
              })
            );
          })
        )
      )
    );
  });
}
